<div [ngClass]="{'formula-panel':!small, 'formula-panel-small':small}" >
    <div [ngClass]="{'formula-left-panel':!small, 'formula-left-panel-small':small}"  >
        <div class="search-panel">
            <div class="filterclass2">
                <mat-form-field class="no-padding-form-field"> 
                <input matInput (keyup)="updateFilter($event)" placeholder="Filtrar Fórmulas">
                </mat-form-field>
            </div>
            <mat-divider></mat-divider>
            <div class="list-formula mat-elevation-z3" >
                <mat-selection-list>
                    <div mat-subheader>Funções</div>
                    <mat-list-item *ngFor="let item of formulaListTemp" (click)="showDesc=true;selectedItem=item" 
                    draggable="true"
                    (dragstart)="dragstart_handler($event)"
                    [attr.data-drag-data]="item|json"
                    >
                    <div class="list-formula-item">
                        <div class="list-icon"><mat-icon mat-list-icon>bolt</mat-icon></div>
                        <div class="item-line">{{item.name}} - {{item.description}}</div>
                    </div>
                    </mat-list-item>
                </mat-selection-list>
            </div>
        </div>
        <mat-divider *ngIf="showDesc"></mat-divider>
        <div [ngClass]="{'box-description':!small, 'box-description-small':small}"  *ngIf="showDesc">
            
            <div class="box-description-detail">
                <div class="box-description-detail-title">Descrição</div>
                <div class="box-description-detail-info">
                    {{selectedItem.description}}
                </div>
                <ng-container  *ngIf="selectedItem.sintaxe" >
                    <mat-divider></mat-divider>
                    <div class="box-description-detail-title">Expressão</div>
                    <div class="box-description-detail-info sintaxe" 
                    draggable="true"
                    (dragstart)="dragstart_handler2($event)"
                    [attr.data-drag-data]="selectedItem.sintaxe|json">
                        {{selectedItem.sintaxe.expression}}({{selectedItem.sintaxe.parameters}})
                    </div>
                </ng-container>
            </div>
        </div>

    </div>
    <mat-divider [vertical]="vertical" ></mat-divider>
    <div [ngClass]="{'formula-right-panel':!small, 'formula-right-panel-small':small}">
        <div class="formula-context">
            <div class="boxtext">
                <mat-form-field appearance="outline" ngClass="customtextarea no-padding-form-field fill-container" >
                    <mat-label>Formula</mat-label>
                    <textarea  matInput type="text"  #value required  [(ngModel)]="formula" (drop)="drop_handler($event)" (ngModelChange)="emitEvent($event)" 
                    ></textarea>
                    <button tabindex="-1" type="button"  *ngIf="value" matSuffix mat-icon-button aria-label="Edit" (click)="executeFormula()" matTooltip="Executar" >
                        <mat-icon tabindex="-1">bolt</mat-icon>
                    </button>
                </mat-form-field>
                
            </div>
            <mat-divider></mat-divider>
            <div class="box-description-result">
                <div class="box-description-detail">
                    <div class="result-formula">
                        {{resultado}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>